<template>
  <div class="not-found-panel md-layout"
       style="  background: rgb(166,166,166);
background: linear-gradient(180deg, rgba(166,166,166,1) 0%, rgba(247,247,247,1) 83%); display: flex; flex-direction: column;">
    <div class="md-layout-item" style="background: #fff; margin:  20px auto; width: 90%; max-width: 600px; -webkit-border-radius: 10px;
-moz-border-radius: 10px;
border-radius: 10px;">
      <h1 style="    text-align: center;
    font-size: 35px;
    margin: 90px 0;"><label v-html="message"></label></h1>
    </div>
  </div>
</template>
<script>
export default {
  name: 'no-survey',
  data: function() {
    return {
      message: ""
    };
  },
  mounted: function() {
    this.message = this.$route.params.message;
  }
};
</script>
